import { type ItemContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types/AppState";
import Component, { type SocialIconItemComponentProps } from "./component";
import { makeStyleSelector } from "./selectors";

export type SocialIconsItemContainerProps = ItemContainerProps & {};
const makeMapStateToProps = () => {
  const socialIconSelector = getSettingValueSelector(TargetSelector.Entity, "socialIcon");
  const styleSelector = makeStyleSelector();

  return (state: AppState, props: SocialIconsItemContainerProps): SocialIconItemComponentProps => {
    const socialIcon = socialIconSelector(state, props);

    return {
      ...props,
      socialIcon,
      style: styleSelector(state, { id: props.parentId, source: props.source })
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
